import {observer} from "mobx-react-lite";
import {SortableItem} from "./SortableItem";
import React from "react";

export const SortableSelectorWrapper = observer(({presetNumber, key, id, overed, srcElement, ctrlKeyPressed}) => {

    return (
        <div className={`sortable-selector-wrapper`}>
        <div className="preset-number">{presetNumber}</div>
        <SortableItem
            presetNumber={presetNumber}
            key={key}
            id={id}
            overed={overed}
            srcElement={srcElement}
            ctrlKeyPressed={ctrlKeyPressed} />
        </div>
    );

});
